// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_1PPcF","hidden":"_3oriV","loader":"_2PuRh","rotate":"_24UPL","active":"_3IBAG","clip":"_1fxrU","clip-reverse":"GdHbw","clipReverse":"GdHbw"};